"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var EmptyLook =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(EmptyLook, _PureComponent);

  function EmptyLook() {
    _classCallCheck(this, EmptyLook);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyLook).apply(this, arguments));
  }

  _createClass(EmptyLook, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width;
      return _react.default.createElement(_IconBase.IconBase, _extends({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 353.17 565.7",
        width: width,
        height: height,
        className: className,
        style: style
      }, this.props), _react.default.createElement("title", null, "Empty Look"), _react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("rect", {
        className: "cls-1",
        fill: "#b3b3b3",
        x: "167.09",
        y: "526.84",
        width: "20.36",
        height: "38.86"
      }), _react.default.createElement("path", {
        className: "cls-2",
        fill: "#ccc",
        d: "M352.17,126.61c-1,43.13-14.68,93.33-26.76,137.6-5.47,20.07-10.6,39.05-14.49,56.63h0c-.07.29-.11.62-.18,1-.19.81-.41,1.65-.56,2.42l.11,0c-.69,4.07-1.5,8.48-2.38,13.14-4.26,23.08-9.58,51.78-9.58,74.39,0,17.29.33,24.63.62,31.71s.67,14.42.67,31.64c0,20-1.18,27.34-1.69,29.58l-.08.33c-.18,4.33-6.86,14.9-64.63,19.63-17.5,1.43-36.33,2.17-56,2.17-15.89,0-31.52-.51-46.35-1.47-46-3-73.73-10.39-74.32-20a134.55,134.55,0,0,1-3.16-30.24c0-17.22.33-24.56.63-31.64s.66-14.42.66-31.71c0-19.74-8-66.1-11.05-83.53l-.7-4c-4-18.46-9.47-38.64-15.26-60C15.54,219.94,1.86,169.74.86,126.61a16.59,16.59,0,0,1,12-16.15C40,102.35,76.18,83.12,90.45,75.23c16.19-8.92,25.73-17.32,28.37-25,2.31-6.79,3.63-22,3.86-34,6.6,5,30.79,7.63,53.84,7.63s47.27-2.68,53.87-7.67c.19,12.08,1.51,27.27,3.86,34.06,2.6,7.71,12.14,16.11,28.33,25,17.76,9.8,51.49,27.42,77.66,35.23A16.56,16.56,0,0,1,352.17,126.61Z"
      }), _react.default.createElement("path", {
        className: "cls-2",
        fill: "#ccc",
        d: "M231,19.47v4.08c0,3.76-20.71,9-54.44,9s-54.37-5.24-54.45-9V19.47a13.63,13.63,0,0,1,9.62-13.19C136.32,4.92,153.25.5,176.52.5s40.19,4.42,44.83,5.78A13.62,13.62,0,0,1,231,19.47Z"
      }), _react.default.createElement("path", {
        className: "cls-1",
        fill: "#b3b3b3",
        d: "M174.25,324C21.61,324,65.6,278.9,18.65,229.09c3.12,12.15,6.39,24.14,9.56,35.71C34,286.14,39.5,306.3,43.46,324.73l.69,4c2.43,14.06,8.13,46.93,10.23,69.45a.5.5,0,0,0,0-.13c21.6-74.51,63.81-53.52,119.83-53.52S285.8,330,285.8,398.08s13.1,101.44-74.36,127.35l-.15.87c7.58-.34,15-.78,22.18-1.37,57.69-4.73,64.36-15.28,64.54-19.61l.08-.33c.51-2.23,1.68-9.56,1.68-29.54,0-17.19-.33-24.52-.66-31.6s-.62-14.4-.62-31.66c0-22.58,5.31-51.24,9.57-74.3.88-4.65,1.68-9.05,2.38-13.12l-.11,0c.14-.77.36-1.61.55-2.42.07-.33.11-.66.18-.95h0c3.88-17.56,9-36.51,14.48-56.56,9.59-35.15,20.18-74.05,24.61-110.17-17.64,28.49-22.62,74.69-33.52,99.55C285.51,325.23,265.93,324,174.25,324Z"
      }), _react.default.createElement("path", {
        className: "cls-3",
        fill: "#fff",
        d: "M190.78,187.34v11.75c0,51-.71,60.66,8,60.66,27.63,0,32.52-35.64,44-56,12.06-21.32,34.55-33.26,34.55-53.86,0-5.62-11.63-6.38-31.94-6.38C204.29,143.62,190.78,152.42,190.78,187.34Z"
      }), _react.default.createElement("path", {
        className: "cls-3",
        fill: "#fff",
        d: "M132.34,86.9C109,78.63,79.28,87.52,52.74,94c14.33-8.1,35.11-16.67,49.91-26.78,5-3.43,9.92-7.4,13.27-12.49a37.77,37.77,0,0,0,2.8-6.1l1.55-6c4.85,21.56,10,26.68,17.29,37.65A4.42,4.42,0,0,1,132.34,86.9Z"
      }), _react.default.createElement("ellipse", {
        className: "cls-3",
        fill: "#fff",
        cx: "177.12",
        cy: "7.6",
        rx: "40.95",
        ry: "7.1"
      }), _react.default.createElement("path", {
        className: "cls-1",
        fill: "#b3b3b3",
        d: "M231.19,23.12c0,16.49-39.88,41.62-35.45,52.3s27.54-4.47,50.78,5.19C272.93,91.59,316,101,316,101l-46.6-22.6-25.15-16-7.36-8.15-4.6-14.67Z"
      }), _react.default.createElement("path", {
        className: "cls-4",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        d: "M231.19,23.09c0,12.11,1.33,20,3.81,27.26,3.63,10.62,20.29,20.29,27.85,24.46,23,12.68,54,28.08,77.25,35a17.4,17.4,0,0,1,12.56,17c-1.45,63.27-29.6,139.4-41.94,197.24"
      }), _react.default.createElement("path", {
        className: "cls-4",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        d: "M122,23.09c0,12.11-1.32,20-3.8,27.26C114.54,61,97.88,70.64,90.31,74.81c-23,12.68-54,28.08-77.24,35a17.39,17.39,0,0,0-12.57,17c1.46,63.27,29.61,139.4,42,197.24,2,11.77,11.7,65.64,11.7,87.14,0,34.4-1.28,28.76-1.28,63.16,0,18,3.18,30.38,3.18,30.38.55,9.66,25.47,17.41,74.92,20.63,14.4.93,30,1.45,46.3,1.45,20,0,38.9-.76,55.89-2.15,44.4-3.63,64.89-11.42,65.3-20.45h0c0-.21,1.73-5.62,1.73-29.86,0-34.4-1.28-28.76-1.28-63.16,0-28.42,8.56-67.07,12.53-90.57"
      }), _react.default.createElement("path", {
        className: "cls-4",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        d: "M176.58.5C194.92.5,211.14,3.2,221,6a13.84,13.84,0,0,1,10.14,13.35v3.81c0,5.23-24.45,9.47-54.61,9.47S122,28.35,122,23.12V19.31A13.84,13.84,0,0,1,132.11,6C142,3.21,158.24.5,176.58.5Z"
      }), _react.default.createElement("line", {
        className: "cls-4",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        x1: "187.45",
        y1: "526.84",
        x2: "187.45",
        y2: "565.7"
      }), _react.default.createElement("line", {
        className: "cls-4",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        x1: "167.09",
        y1: "526.84",
        x2: "167.09",
        y2: "565.7"
      }))));
    }
  }]);

  return EmptyLook;
}(_react.PureComponent);

EmptyLook.displayName = 'EmptyLook'; // Prop Types

EmptyLook.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
EmptyLook.defaultProps = {
  className: '',
  style: {},
  height: '408',
  width: '408'
};
var _default = EmptyLook;
exports.default = _default;